<template>

  <v-container fluid class="px-0 mt-0 pt-0 page page-shipper-item">

    <!-- Page Content -->
    <v-container fluid>
      <transition name="fade-flash" mode="out-in">
        <router-view />
      </transition>
    </v-container>

  </v-container>

</template>

<script>
export default {
  name: 'ShipperRootPage',

  props: {
    shipperId: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>
</style>
